import {
  LOG_LIST_PAGE_LOADED,
  LOG_LIST_NEXT_PAGE_LOADED,
  LOG_LIST_PAGE_UNLOADED
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
  switch (action.type) {
    case LOG_LIST_PAGE_LOADED:
    case LOG_LIST_NEXT_PAGE_LOADED:
      return {
        ...state,
        logs: action.payload.logs,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE)
      }
    case LOG_LIST_PAGE_UNLOADED:
      return {}
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/log.js